export default (state) => state.administratorPermissions
